﻿<div [ngClass]="style?.cssClass || 'card'">
  @if (title) {
    <div [ngClass]="style?.header?.cssClass || 'card-header d-flex align-items-center'">
      <ng-container *ngTemplateOutlet="headerTemplate || defaultHeaderTemplate; context:{title: title, defaultHeaderTemplate: defaultHeaderTemplate}"></ng-container>
    </div>
  }

  <div [ngClass]="style?.content?.cssClass || 'card-body'">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </div>

  @if (editing) {
    <div [ngClass]="style?.footer?.cssClass || 'card-footer d-flex align-items-center'">
      <ng-container *ngTemplateOutlet="footerTemplate || defaultFooterTemplate; context:{defaultFooterTemplate: defaultFooterTemplate}"></ng-container>
    </div>
  }
</div>

<ng-template #defaultHeaderTemplate let-title="title">
  <div class="card-title flex-fill mb-0 text-capitalize-first">{{ title }}</div>
  <ng-container *ngTemplateOutlet="editButtonTemplate"></ng-container>
</ng-template>

<ng-template #defaultFooterTemplate>
  <div [ngClass]="style?.footer?.groupCssClass">
    @if (saveButtonState.visible) {
      <button type="button" [ngClass]="saveButtonState.cssClass || 'btn btn-primary me-lg-2'" (click)="save()" [disabled]="saveButtonState.disabled || !canSave ? true : null">
        <span class="material-symbols-rounded">save</span>
        {{ 'UI.Label.Save|Mentés' | translate }}
      </button>
    }
    @if (cancelButtonState.visible) {
      <button type="button" [ngClass]="cancelButtonState.cssClass || 'btn btn-secondary'" (click)="cancel()" [disabled]="cancelButtonState.disabled ? true : null">
        <span class="material-symbols-rounded">block</span>
        {{ 'UI.Label.Cancel|Mégsem' | translate }}
      </button>
    }
    @if (okButtonState.visible) {
      <button type="button" [ngClass]="okButtonState.cssClass || 'btn btn-primary'" (click)="cancel()" [disabled]="okButtonState.disabled ? true : null">
        <span class="material-symbols-rounded">check</span>
        {{ 'UI.Label.Ok|OK' | translate }}
      </button>
    }
  </div>
</ng-template>

<ng-template #editButtonTemplate let-class>
  @if (editButtonState.visible) {
    <button [ngClass]="editButtonState.cssClass || 'btn btn-outline-secondary'" (click)="edit(false)" [attr.disabled]="editButtonState.disabled || editing ? true : null">
      <span class="material-symbols-rounded">edit</span>
    </button>
  }
</ng-template>

<ng-template #newButtonTemplate let-class>
  @if (newButtonState.visible) {
    <button [ngClass]="newButtonState.cssClass || 'btn btn-outline-secondary'" (click)="edit(true)" [attr.disabled]="newButtonState.disabled || editing ? true : null">
      <span class="material-symbols-rounded">add</span>
    </button>
  }
</ng-template>
